import Rails from '@rails/ujs'

// Controllers
import '../controllers'

// Components
import '../components'

console.log('Application.js loaded')
